import { keySetFromMap } from "../../../../utils/immutableExtensions";
import { typeSelectors } from "../../../definition/types";
import { itemSelectors } from "../../../items";

// Changes:
//  - initials
const updateItemInitials = (state, newAndChangedIdSet, newItemsById, newTypesById, prevTypesById) => {
  // Because we merge ItemRecord into ItemDisplayRecord for all changed items,
  // and ItemRecord has a field called "initials" that might be null,
  // we need to set the initials again for every single item that has changed
  // because its old default value will have been replaced by the null

  let affectedIds = newTypesById === prevTypesById ? newAndChangedIdSet : keySetFromMap(state);

  if (!affectedIds.size) {
    return state;
  }

  return state.withMutations(s => {
    affectedIds.forEach(cId => {
      const item = newItemsById.get(cId);
      const isAvatar = typeSelectors.isAvatarType(newTypesById.get(item.type));
      if (isAvatar) {
        s.update(cId, d => d.set("initials", item.initials ? item.initials : itemSelectors.getInitialsForItem(item)));
      }
    });
  });
};

export default updateItemInitials;
